<div class="container-fluid">
    <div class="row min-vh-100 flex-center g-0">
    <div class="card">
        <div class="card-header">
            Gentle Reminder
        </div>
        <div class="card-body">
            <h3>Your trial subscription has end. Please subcribe to our plan to continue.
                <br>
            </h3>
    
            <div class="text-center">
                <button class="btn btn-primary" routerLink="/auth/subscription">
                    Choose Plan
                </button>
            </div>
        </div>
        </div>
    </div>
</div>